// import {h} from 'preact';
import React from 'react';
import styles from './styles.css';
import {observer, inject} from 'mobx-react';

import {ListItem} from 'react-toolbox/lib/list';

function NavLink({view, route, router}) {
  return (
      <ListItem
        theme={styles}
        className={view.currentRoute.pattern === route.pattern ? styles.active : null}
        selectable
        caption={route.name}
        onClick={() => router.navigate(route.pattern)}
      />
  )
}

export default inject('view', 'router')(observer(NavLink));


// WEBPACK FOOTER //
// ./src/components/NavLink/NavLink.js